module.exports = __webpack_public_path__ + "img/award_share_img.b7b71f75.png";